import { SET_GIVEAWAY_LANDING_ANSWER_ERROR } from '../giveaway-landing.actions';
export const giveawayErrorReducerStateInitialState = '';
export const giveawayErrorReducerFactory = (state = giveawayErrorReducerStateInitialState, action) => {
  switch (action.type) {
    case SET_GIVEAWAY_LANDING_ANSWER_ERROR:
      {
        return action.payload;
      }
    default:
      {
        return state;
      }
  }
};